var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "saving" }, [
      _vm._v("\n    Saving "),
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }